import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Card, Alert, Spinner, Row, Col, ButtonGroup, Accordion } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faCalendarAlt, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { materiacursos, cursos } from '../services/materiascursos';
//AV
import { setPidmByUser, getUserPidm } from '../services/login';
//import { getuserlogged, getusernamelogged, getusercodeidlogged, getuserperiodlogged, getuserdescperiodlogged } from '../services/login';
import { listaperiodos } from '../services/periodos';
//import { guardar_horario } from '../services/horarios';
import Error from './Error';
import { useHistory } from "react-router-dom";
import { urlbase } from '../utils/utils';
import RenderProfesores from '../components/commons/RenderProfesores';

function Horariofiltroscoord(props) {
	let history = useHistory();
	const [errormensaje, setErrormensaje] = useState([]);
	const [errorform, setErrorform] = useState([]);
	const [listproyeccion, setListproyeccion] = useState([]);
	const [show, setShow] = useState(false);
	const [periodo, setPeriodo] = useState('');
	const [periodos, setPeriodos] = useState('');
	const [desc_periodo, setDesc_periodo] = useState('');
	const [proyeccion, setProyeccion] = useState(false);
	const [listItems, setlistItem] = useState([]);
	const handleClose = () => setShow(false);

	const [spinner, setSpinner] = useState(false);
	const [creditos, setCreditos] = useState(0);
	const [materiascursos, setMateriascursos] = useState([]);
	const [materiascursos2, setMateriascursos2] = useState([]);

	const [tiempoconsulta, setTiempoconsulta] = useState(Date.now());
	const [usuario, setUsuario] = useState('');

	const handleShow = async () => {
		let listproyeccion_temp = "";
		let usuario = document.getElementById("usuario").value;
		let sel_periodo = document.getElementById("periodo");
		let periodo = sel_periodo.options[sel_periodo.selectedIndex].value;
		let descr_periodo = sel_periodo.options[sel_periodo.selectedIndex].text;

		if (usuario !== "" && periodo !== "Seleccione el periodo") {
			// AV
			if (await setPidmByUser(usuario.toLowerCase())) {
				usuario = getUserPidm();
			}

			setErrorform('');
			setUsuario(usuario);

			//console.log(materiascursos);
			//var periodo= getuserperiodlogged();
			//var desc_periodo= getuserdescperiodlogged();
			//periodo = '202210';
			setPeriodo(periodo);
			setDesc_periodo(descr_periodo);
			setSpinner(true);

			//console.log("materiacursos(usuario, periodo) " + usuario + " - " + periodo + " - " + desc_periodo);

			materiacursos(usuario, periodo)
				.then(
					res => {
						//console.log(res.data);
						listproyeccion_temp = res.data;
						setListproyeccion(listproyeccion_temp);
						setSpinner(false);

						//console.log(listproyeccion_temp);
						llenarproyeccion(listproyeccion_temp, materiascursos);
						setShow(true);
					}
				)
				.catch(
					errorcatch
				);
		} else {
			setErrorform(Error('Debe ingresar el usuario y el periodo.'));
		}
	}

	//Obtiene los creditos de la materiacurso seleccionado
	const onchangematcurso = (e) => {
		if (e.target.type === 'checkbox' && e.target.checked) {
			setCreditos((cred) => cred + parseInt(document.getElementById(e.target.value).value));
		} else {
			//setCreditos((cred)=>Math.max (0,cred  - parseInt(document.getElementById(e.target.value).value)));
			setCreditos((cred) => cred - parseInt(document.getElementById(e.target.value).value));
		}
	}

	const onchangefiltromatcur = (e) => {
		let matcurso = e.target.value;
		if (e.target.type === 'checkbox' && e.target.checked) {
			props.selectcursos[matcurso].matcur_activo = true;
			props.selectcursos[matcurso].profesores_seleccionados = [];
			props.selectcursos[matcurso].keys = [];
			props.selectcursos[matcurso].count = 0;
			props.selectcursos[matcurso].countmax = 0;
			/*props.selectcursos[matcurso].nrcs.map((index)=>{
				props.selectcursos[matcurso].keys.push(index);
				props.selectcursos[matcurso].keys.sort();
				props.selectcursos[matcurso].count = 0;
				props.selectcursos[matcurso].countmax = props.selectcursos[matcurso].keys.length;							
			})*/
		} else {
			props.selectcursos[matcurso].matcur_activo = false;
		}
		props.selectcursos[matcurso].horario = [];
		props.selectcursos[matcurso].horario = props.selectcursos[matcurso][props.selectcursos[matcurso].keys[0]];
		//console.log(props.selectcursos);
		props.setSelectcursos(props.selectcursos);
		props.setCursokey(!props.cursokey);
	}

	const onchangefiltroprofesor = (e) => {
		let info_profesor = e.target.id.split("_");
		let matcurso = info_profesor[0];
		let nombre_profesor = info_profesor[1];
		if (e.target.type === 'checkbox' && e.target.checked) {
			props.selectcursos[matcurso].nrcs.map((index) => {
				let bloqueado = true;
				if (props.selectcursos[matcurso][index]['PROFESOR'] === nombre_profesor) {
					if (!props.selectcursos[matcurso].profesores_seleccionados.includes(nombre_profesor)) {
						props.selectcursos[matcurso].profesores_seleccionados.push(nombre_profesor);
					}
					let dias = props.selectcursos[matcurso][index]['DIAS'].split("/");
					let horas = props.selectcursos[matcurso][index]['HORAS'].split("/");
					for (let i = 0; i < dias.length; i++) {
						let infodia = dias[i];
						let infohora = horas[i].split("_");
						let horai = infohora[0];
						let horaf = infohora[1];

						props.tabla.map((data1, index1) => {
							data1.map((data2, index2) => {
								let info = data2.split('-');
								let diamatriz = info[0];
								let horaimatriz = info[1].replace(':', '');
								let horafmatriz = info[2].replace(':', '');

								if (infodia === diamatriz) {
									if ((horai >= horaimatriz || horai <= horafmatriz) && (horaf <= horafmatriz || horaf >= horaimatriz)) {
										if (bloqueado) {
											if (props.bloqueos[index1][index2] === false) {
												if (!props.selectcursos[matcurso].keys.includes(index)) {
													props.selectcursos[matcurso].keys.push(index);
													props.selectcursos[matcurso].keys.sort();
													props.selectcursos[matcurso].count = 0;
													props.selectcursos[matcurso].countmax = props.selectcursos[matcurso].keys.length;
												}
											} else {
												let posnrckey = props.selectcursos[matcurso].keys.findIndex((element) => element === index);
												props.selectcursos[matcurso].keys.splice(posnrckey, 1);
												props.selectcursos[matcurso].count = 0;
												props.selectcursos[matcurso].countmax = props.selectcursos[matcurso].keys.length;
												bloqueado = false;
											}
										}
									}
								}
							})
						})
					}
				}
			})
		} else {
			if (props.selectcursos[matcurso].keys.length === 0) {
				let posprof = props.selectcursos[matcurso].profesores_seleccionados.findIndex((element) => element === nombre_profesor);
				props.selectcursos[matcurso].profesores_seleccionados.splice(posprof, 1);
				props.selectcursos[matcurso].count = 0;
				props.selectcursos[matcurso].countmax = props.selectcursos[matcurso].keys.length;
			} else {
				let sw = true;
				let posicioneseliminarkeys = []
				props.selectcursos[matcurso].keys.map((data, index) => {
					if (props.selectcursos[matcurso][data]['PROFESOR'] === nombre_profesor) {
						let posprof = props.selectcursos[matcurso].profesores_seleccionados.findIndex((element) => element === nombre_profesor);
						props.selectcursos[matcurso].profesores_seleccionados.splice(posprof, 1);
						posicioneseliminarkeys.push(data);
						sw = false;
					}
				})
				posicioneseliminarkeys.map((data2, index2) => {
					let posnrckey = props.selectcursos[matcurso].keys.findIndex((element) => element === data2);
					props.selectcursos[matcurso].keys.splice(posnrckey, 1);
				})
				props.selectcursos[matcurso].count = 0;
				props.selectcursos[matcurso].countmax = props.selectcursos[matcurso].keys.length;
				if (sw) {
					let posprof = props.selectcursos[matcurso].profesores_seleccionados.findIndex((element) => element === nombre_profesor);
					props.selectcursos[matcurso].profesores_seleccionados.splice(posprof, 1);
				}
			}
		}
		props.selectcursos[matcurso].horario = [];
		props.selectcursos[matcurso].horario = props.selectcursos[matcurso][props.selectcursos[matcurso].keys[0]];
		//console.log(props.bloqueos);
		//console.log(props.selectcursos);
		props.setSelectcursos(props.selectcursos);
		props.setCursokey(!props.cursokey);
	}

	//Construye el array con los materias cursos seleccionados
	const consultarnrc = () => {
		setTiempoconsulta(Date.now());
		let objmateriascursos = [];
		let selectmateriascurtemp = [];
		let selectmateriascurtemp2 = [];
		let checkboxes = document.getElementsByName('checkboxmatcurso[]');

		checkboxes.forEach(element => {
			if (element.checked) {
				objmateriascursos = { "matcur": element.value, "nombre": element.id };
				selectmateriascurtemp.push(element.value);
				selectmateriascurtemp2.push(objmateriascursos);
			}
		});
		//AV
		if (selectmateriascurtemp.length === 0) {
			setShow(false);
			return false;
		}
		//setMateriascursos(selectmateriascurtemp);
		//setMateriascursos2(selectmateriascurtemp2);
		setSpinner(true);
		//console.log(usuario);
		//console.log(selectmateriascurtemp);
		//console.log(periodo);
		//console.log(selectmateriascurtemp2);
		//console.log("Horariofiltroscoord consultarnrc " );
		//console.log("cursos( " +  usuario +"," + selectmateriascurtemp + "," +periodo +")");

		cursos(usuario, selectmateriascurtemp, periodo).then(
			res => {
				//console.log(res.data);								
				for (let matcu in res.data) {
					for (let curso in res.data[matcu]) {
						//res.data[matcu][curso].NRC_ACTIVO = true;
						if (!res.data[matcu].keys) {
							res.data[matcu].keys = [];
						}
						if (!res.data[matcu].nrcs) {
							res.data[matcu].nrcs = [];
						}
						//res.data[matcu].keys.push(curso);
						res.data[matcu].nrcs.push(curso);
					}
					//res.data[matcu].conflicto = false;
					res.data[matcu].profesores_seleccionados = [];
					res.data[matcu].matcur_activo = true;
					res.data[matcu].horario = undefined;
					//res.data[matcu].horario = res.data[matcu][res.data[matcu].keys[0]];
					res.data[matcu].count = 0;
					//res.data[matcu].countmax = res.data[matcu].keys.length;
					res.data[matcu].countmax = 0;
				}
				props.setSelectcursos(res.data);
				setMateriascursos(selectmateriascurtemp);
				setMateriascursos2(selectmateriascurtemp2);
				//console.log(props.selectcursos);
				setSpinner(false);
				let currentdate = new Date();
				let datetime = "La información fue consultada el: " + currentdate.getDate() + "/"
					+ (currentdate.getMonth() + 1) + "/"
					+ currentdate.getFullYear() + " - "
					+ currentdate.getHours() + ":"
					+ currentdate.getMinutes() + ":"
					+ currentdate.getSeconds();
				props.setFecha(datetime);
			}
		).catch(
			errorcatch
		);
		setCreditos(0);
		handleClose();
	}

	const descargar_nrc = () => {
		window.print();
	}

	const searchnrc = (materia, cont) => {
		//alert(materia +'->'+ cont);
		//alert(props.selectcursos[materia].keys[cont]);
		let temporal = props.selectcursos;
		let curso = temporal[materia][temporal[materia].keys[cont]];
		temporal[materia].count = cont;
		temporal[materia].horario = [];
		//temporal[materia].horario.push(curso);
		temporal[materia].horario = curso;

		props.setSelectcursos(temporal);
		props.setCursokey(!props.cursokey);
		//console.log(props.selectcursos);
		//console.log(horario);
	}

	/*const renderprofesores = (matcurso)=>{
		var listaprofesores = [];
		if(props.selectcursos[matcurso]){
			props.selectcursos[matcurso].nrcs.forEach((nrc)=>{						
				if(!listaprofesores.includes(props.selectcursos[matcurso][nrc]['PROFESOR'])){
					listaprofesores.push(props.selectcursos[matcurso][nrc]['PROFESOR']);
				}
			})
		}
		//console.log('LISTA DE PROFESORES');
		//console.log(listaprofesores);
		return(
			listaprofesores.sort().map((profesor, key)=>
				<li key={tiempoconsulta+profesor}>
					<Form.Group controlId={matcurso+"_"+profesor}>
						<Form.Check 
							value={profesor}
							type="switch" 
							label={profesor.toUpperCase()}
							name="checkboxprofesores[]"
							onChange={onchangefiltroprofesor}
						/>
					</Form.Group>
				</li>
			)
		)		
	}*/

	const renderMateriascursosselect = () => {
		return (
			materiascursos2.map((matcurselect, key) =>
				<li key={matcurselect + "-" + key + tiempoconsulta}>
					<Row>
						<Col xs={8}>
							<Form.Group controlId={"matsel_" + matcurselect.matcur}>
								<Form.Check
									disabled={props.selectcursos[matcurselect.matcur] ? false : true}
									value={matcurselect.matcur}
									type="switch"
									label={matcurselect.nombre}
									name="checkboxmatcurso2[]"
									defaultChecked="true"
									onChange={onchangefiltromatcur}
								/>
							</Form.Group>
						</Col>
						{props.selectcursos[matcurselect.matcur] && props.selectcursos[matcurselect.matcur].matcur_activo &&
							<Col xs={4} className="selectnrc">
								<ButtonGroup aria-label="Basic example">
									{props.selectcursos[matcurselect.matcur] && props.selectcursos[matcurselect.matcur].count > 0 &&
										<Button
											onClick={() => searchnrc(matcurselect.matcur, props.selectcursos[matcurselect.matcur].count - 1)}
											variant="primary"
											size="sm"
											className="searchnrc"
										>
											<FontAwesomeIcon icon={faChevronLeft} />
										</Button>
									}
									{props.selectcursos[matcurselect.matcur] &&
										<span className="selectnrccount">{props.selectcursos[matcurselect.matcur].countmax === 0 ? 0 : props.selectcursos[matcurselect.matcur].count + 1}/{props.selectcursos[matcurselect.matcur].countmax}</span>
									}
									{props.selectcursos[matcurselect.matcur] && props.selectcursos[matcurselect.matcur].count + 1 < props.selectcursos[matcurselect.matcur].countmax &&
										<Button
											onClick={() => searchnrc(matcurselect.matcur, props.selectcursos[matcurselect.matcur].count + 1)}
											variant="primary"
											size="sm"
											className="searchnrc"
										>
											<FontAwesomeIcon icon={faChevronRight} />
										</Button>
									}
								</ButtonGroup>
							</Col>
						}
					</Row>
					<Row>
						{props.selectcursos[matcurselect.matcur] && props.selectcursos[matcurselect.matcur].matcur_activo &&
							<Col md={12}>
								{props.selectcursos[matcurselect.matcur] && props.selectcursos[matcurselect.matcur].horario !== undefined &&
									<Alert className={props.selectcursos[matcurselect.matcur].horario['DISPONIBLES'] > 0 ? "alertinfo" : "alert alert-danger"} variant="primary" id={props.selectcursos[matcurselect.matcur].horario['NRC']} name={props.selectcursos[matcurselect.matcur].horario['NRC']}>
										<p><strong>Materia curso: </strong>{props.selectcursos[matcurselect.matcur].horario['MATCURSO']} - <strong>Nrc: </strong>{props.selectcursos[matcurselect.matcur].horario['NRC']}</p>
										<p><strong>Profesor(es): </strong> {(props.selectcursos[matcurselect.matcur].horario['LISTA_PROFESORES'] === null ? props.selectcursos[matcurselect.matcur].horario['PROFESOR'].toUpperCase() : props.selectcursos[matcurselect.matcur].horario['LISTA_PROFESORES']).toUpperCase()} {/*props.selectcursos[matcurselect.matcur].horario['PROFESOR'].toUpperCase()*/}</p>
										<p><strong>Cupos disponibles: </strong>{props.selectcursos[matcurselect.matcur].horario['DISPONIBLES']}</p>
										<p><strong>Máximo en lista de espera: </strong> {props.selectcursos[matcurselect.matcur].horario['MAX_LISTA_ESPERA']} <strong>Real: </strong> {props.selectcursos[matcurselect.matcur].horario['LISTA_ESPERA_REAL']} <strong>Restante: </strong> {props.selectcursos[matcurselect.matcur].horario['RESTANTE_LISTA_ESPERA']} </p>
										<p><strong>{props.selectcursos[matcurselect.matcur].horario['INCLUIR_EXCLUIR']} </strong></p>
									</Alert>
								}
							</Col>
						}
					</Row>
					<Row>
						{props.selectcursos[matcurselect.matcur] && props.selectcursos[matcurselect.matcur].matcur_activo &&
							/*<ul className="listaprofesores">
								
									{renderprofesores(matcurselect.matcur)}
														
							</ul>*/
							<RenderProfesores
								matcurso={matcurselect.matcur}
								selectcursos={props.selectcursos}
								onchangefiltroprofesor={onchangefiltroprofesor}
								tiempoconsulta={tiempoconsulta}
							/>
						}
					</Row>
				</li>
			)
		)
	}

	const llenarproyeccion = (data, seleccionados) => {
		//console.log(seleccionados);
		let cred = 0;
		if (data.length > 0) {
			setProyeccion(true);
			data.map((matcur, key) => {
				if (seleccionados.includes(matcur.MATERIACURSO)) {
					cred = cred + matcur.CREDITOS;
				}
			});
			setlistItem(
				data.map((matcur, key) =>
					<li key={matcur.MATERIACURSO + "-" + key}>
						<Form.Group controlId={matcur.NOMBRE}>
							<Form.Check
								onChange={onchangematcurso}
								value={matcur.MATERIACURSO}
								type="switch"
								//label={matcur.NOMBRE+" - "+matcur.MATERIACURSO+" - ("+matcur.CREDITOS+")"}
								label={matcur.NOMBRE}
								name="checkboxmatcurso[]"
								defaultChecked={seleccionados.includes(matcur.MATERIACURSO)}
							/>
							<span className="infomatcurcred"><strong>Materia curso: </strong>{matcur.MATERIACURSO} <strong>Créditos: </strong>{matcur.CREDITOS}</span>
						</Form.Group>

						<Form.Group controlId={matcur.MATERIACURSO}>
							<Form.Control type="hidden" value={matcur.CREDITOS} />
						</Form.Group>
					</li>
				)
			)
			setCreditos(cred);
		} else {
			setProyeccion(false);
			setlistItem(<Alert variant="danger">Aún no hay asignaturas para el periodo seleccionado en la proyección.</Alert>)
		}
	}

	function errorcatch(error) {
		//console.log(error);
		if (error.response.status === 500) {
			setErrormensaje(Error(error.response.data.mensaje));
		}
		if (error.response.status === 403) {
			setErrormensaje(Error(error.response.data.mensaje));
			setTimeout(() => history.push(urlbase), 5000);
		}
	}
	useEffect(() => {
		listaperiodos().then(
			res => {
				//console.log(res.data);
				setPeriodos(
					res.data.map((periodo, key) =>
						<option key={key} value={periodo.COD_PERIODO}>{periodo.DESC_PERIODO}</option>
					)
				)
			}
		).catch(
			errorcatch
		);
	}, []);
	return (
		<div>
			{errormensaje !== "" && errormensaje}
			{errorform !== "" && errorform}
			<Form>
				<Form.Group className="mb-3" controlId="usuario">
					<Form.Label>Usuario estudiante:</Form.Label>
					<Form.Control type="text" placeholder="Usuario" />
				</Form.Group>

				<Form.Group className="mb-3" controlId="periodo">
					<Form.Label>Seleccione el periodo:</Form.Label>
					<Form.Control
						as="select"
					/* onChange={onchangeperiodo}*/
					>
						<option disabled selected>Seleccione el periodo</option>
						{periodos}
					</Form.Control>
				</Form.Group>

				<Button controlId="proyeccion" className="btn_icon float-left" variant="success" onClick={handleShow}>
					<FontAwesomeIcon icon={faCalendarAlt} />
					Consultar proyección
					{spinner && <Spinner
						as="span"
						animation="border"
						size="sm"
						role="status"
						aria-hidden="true"
					/>}
				</Button>
			</Form>
			{materiascursos2.length > 0 &&
				<Button id="descargar" className="btn_icon float-right" variant="success" onClick={descargar_nrc}>
					<FontAwesomeIcon icon={faFileDownload} />
					Guardar horario
				</Button>
			}
			<Modal scrollable show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Mi proyección - {periodo}</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{spinner && <Spinner
						as="span"
						animation="border"
						role="status"
						aria-hidden="true"
						variant="primary"
					/>}
					<Form id="matcursoForm">
						{proyeccion &&
							<div>
								<p className="alert alert-danger">Si eres un estudiante de <strong>ciencias de la salud</strong>, ten en cuenta que tus horarios pueden variar de semana en semana.</p>
								<p className="text-primary">Total de creditos seleccionados: {creditos}</p>
							</div>
						}
						{creditos > 1000 &&
							<Alert variant="warning">
								Ten en cuenta que has excedido 18 créditos.
							</Alert>
						}
						<ul className="listamatcurso">
							{listItems}
						</ul>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					{proyeccion &&
						<Button variant="success" onClick={consultarnrc}>
							Consultar cursos
						</Button>
					}

				</Modal.Footer>
			</Modal>

			{materiascursos2.length > 0 &&
				<div>
					<Col className="clear" md={12}>
						<span className="text-info info">{props.fecha}</span>
					</Col>
					<Accordion defaultActiveKey="0">
						<Card>
							<Card.Header>
								<Accordion.Toggle as={Button} variant="link" eventKey="0">
									Materias seleccionadas
									{spinner && <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
									/>}
								</Accordion.Toggle>
							</Card.Header>
							<Accordion.Collapse className="filtrosmatcur" eventKey="0">
								<Card.Body>
									<ul className="listamatcur">
										{renderMateriascursosselect()}
									</ul>
								</Card.Body>
							</Accordion.Collapse>
						</Card>
					</Accordion>
				</div>
			}
		</div>
	);
}

export default Horariofiltroscoord;